<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header d-flex justify-between align-items-center gap-2">
            <div style="width: 100%;">
              <h2>Manage Agents</h2>
            </div>
            <div>
              <button class="cursor-pointer btn btn-primary text-white" style="width: 100px;" (click)="addMerchant()" >Add </button>
            </div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>

            <div class="table-responsive" *ngIf="changeOccured">
              <table id="agents-lists" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>#</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>State</th>
                  <th>LGA</th>

                  <th>Action</th>

                  <th>Wallet Bal.</th>
                  <th>Status</th>

                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>#</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>State</th>
                  <th>LGA</th>

                  <th>Action</th>

                  <th>Wallet Bal.</th>
                  <th>Status</th>

                </tr>
                </tfoot>
                <tbody>
                <tr *ngFor="let agent of myAgents;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{ agent?.first_name }}</td>
                  <td>{{ agent?.last_name }}</td>
                  <td>{{ agent?.email }}</td>
                  <td>{{ agent?.phone_no }}</td>
                  <td>{{ agent?.state?.name }}</td>
                  <td>{{ agent?.lga?.name }}</td>

                  <td>
                    <div>at
                      <!-- <span role="button" data-balloon="View Details" data-balloon-pos="up" (click)="ViewAgent(agent.id)">
                        <i class="fa fa-eye text-info"></i>
                      </span> -->
                      <button [disabled]="actionId === agent.id" class="btn btn-sm btn-success" *ngIf="agent?.status.toLowerCase() === 'inactive'" (click)="toggleAgentStatus(agent, 'enable')">{{ actionId === agent.id ? 'Enabling' :  'Enable Agent'}}</button>
                      <button [disabled]="actionId === agent.id" class="btn btn-sm btn-danger" *ngIf="agent?.status.toLowerCase() === 'active'" (click)="toggleAgentStatus(agent, 'disable')">{{ actionId === agent.id ? 'Disabling' : 'Disable Agent'}}</button>
                    </div>
                  </td>
                  <th>{{ agent?.wallet_balance || 0 | currency: '&#8358;' }}</th>

                  <td>
                    <span class="badge badge-info" *ngIf="agent?.status.toLowerCase() === 'inactive'">Awaiting Approval</span>
                    <span class="badge badge-success" *ngIf="agent?.status.toLowerCase() === 'active'">Approved</span>
                  </td>

                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Agent modal -->
<app-modal [modalTitle]="'Add Agent'" [modalId]="'addagent'" >
  <form class="form-auth-small" [formGroup]="addAgentForm" (ngSubmit)="submitAgentForm()">
    <div class="modal-body">
      <div class="d-flex align-items-center justify-content-between mb-2" style="gap: 10px;">
        <!-- firstname input -->
        <div>
          <label for="fname" class="control-label">First Name</label>
          <input id="fname" name="first_name" type="text" class="form-control" placeholder="First Name" formControlName="first_name" autocomplete="given-name">
        </div>
        <!-- last name input -->
        <div>
          <label for="lname" class="control-label">Last Name</label>
          <input id="lname" name="last_name" type="text" class="form-control" placeholder="Last Name" formControlName="last_name" autocomplete="family-name">
        </div>
      </div>
  
      <div class="d-flex align-items-center justify-content-between mb-2" style="gap: 10px;">
        <!-- email input -->
        <div>
          <label for="email" class="control-label">Email</label>
          <input id="email" name="email" type="email" class="form-control" placeholder="Enter your email" formControlName="email" autocomplete="email">
        </div>
        <!-- phone input -->
        <div>
          <label for="phone" class="control-label">Phone</label>
          <input maxlength="11" id="phone" name="phone_no" type="text" class="form-control" placeholder="Phone Number" formControlName="phone_no" autocomplete="tel">
          <small class="text-danger" *ngIf="getPhoneNumberError()">Max length 11; must be Number.</small>
        </div>
      </div>
  
      <div class="d-flex">
        <!-- lga input -->
        <div style="width: 100%;">
          <label for="lga" class="control-label">Select Local Govt</label>
          <select id="lga" name="lga_id" class="form-control" formControlName="lga_id" autocomplete="address-level2">
            <option value="">Select Local Government</option>
            <option *ngFor="let lg of locals" [value]="lg.lga_id">
              {{lg.name}}
            </option>
          </select>
        </div>
      </div>
    </div> 
  
    <div class="modal-footer">
      <button type="submit" *ngIf="!submitting" [disabled]="addAgentForm.invalid" class="btn btn-primary">Add</button>
      <span *ngIf="submitting" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
      <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
    </div>
  </form>
</app-modal>
